import axios from "axios";
import { GET_ALL_SUBS_PACKAGE, GET_ALL_SUBS_PACKAGE_SUCCESS, GET_ALL_SUBS_PACKAGE_FAILED } from "../../constants/subsPackageConstants";

export  const GetAllSubsPackage = () => async(dispatch) => {
            dispatch({type: GET_ALL_SUBS_PACKAGE});
        try {
            const res = await axios.get("/store/product?latest=1");
            dispatch({type: GET_ALL_SUBS_PACKAGE_SUCCESS, payload: res.data});

        } catch(error) {
            dispatch({type: GET_ALL_SUBS_PACKAGE_FAILED, payload: error.message});
        }
}

